import { LinearProgress } from "@mui/material";
import React from "react";

const Loader = ({ show = false }) => {
  return (
    <div className={`${show ? "block" : "hidden"} relative !bg-white`}>
      <div className="absolute m-[auto] top-0 bottom-0 left-0 right-0 z-[10000]">
        <LinearProgress className="h-[5px]" color="primary" />
      </div>
    </div>
  );
};

export default Loader;
